import { useState } from "react";


function App() {
  
    const [ peso,setPeso] = useState("");
    const [ altura, setAltura] = useState("");
    const [ resultado , setResultado] = useState("");


    function calcular(e){
      // e.preventDefault();

        if(!peso || !altura){
          setResultado("Por favor, preencha todos os campos!");
          return;
        }

        const imc = (Number(peso) / (Number(altura) * Number(altura)));


        let mensagem = "";

        if(imc < 17){
          mensagem = "Cuidado, você está muito abaixo do peso!";
        }else if(imc <= 18.49){
          mensagem = "Você está abaixo do peso!";

        }else if(imc >= 18.5 && imc < 24.99){
          mensagem = "Você está no peso ideal!";
        }else if(imc >= 25 && imc <= 29.99){
          mensagem = "Você está acima do peso!";

        }else if(imc >= 30){
          mensagem = "Você está obeso, procure um médico!";
        }

      setResultado(`Seu IMC é: ${imc.toFixed(2)} - ${mensagem}`);

      // Limpar campos
      setPeso("")
      setAltura("");
    }

    function limpaForm(e){
      e.preventDefault();
      setPeso("");
      setAltura("");
      setResultado("");
    }


  return(
    <div className="app">
     <h1>Calculadora IMC</h1>
      <form>
        <label>Altura:</label><br/>
        <input
        placeholder="Digite sua altura" 
        type="text"        
        value={altura}
        onChange={(e) => {
          const valor = e.target.value
          .replace(/[^0-9.]/g, "") //remove letras e caracteres especiais, exceto números, vírgula e ponto
          .slice(0, 4); // limita a entrada a 4 caracteres
          setAltura(valor);
        }}
        /> <br/>

        <label>Peso:</label><br/>
        <input 
        placeholder="Digite seu peso"
        type="number"
        value={peso}
        onChange={(e) => {const valor = e.target.value
          .replace(/[^0-9.,]/g,"") //remove letras e caracteres especiais, exceto números, vírgula e ponto
          .slice(0,3);
          setPeso(valor);
        }}
        /> <br/>
        
      </form>

      <div>
          <div className="botoes" >
            <button className="botao-1" type="submit" onClick={calcular}>
              Resultado
            </button>
          
            <button className="botao-2" type="button" onClick={limpaForm}>
              Limpar
            </button>
           </div>
        </div>

      

      <div>
        <span>{resultado}</span>
        
      </div>
    </div>
  )

}

export default App;